export class AddPlayerAddressMetaRequestDTO {
  constructor() {
    this.address = null;
    this.guild_id = null;
    this.user_agent = null;
  }
}